import React, { useState, useRef, useEffect } from "react";
import style from "./style";
import Image from "@/bit/components/next13.components.c-image";

const Video = ({ videoMP4, videoWebM, alt, playVideo }) => {
  const ref = useRef();

  useEffect(() => {
    const video = ref.current.children[0];

    if (playVideo) {
      video.play();
    }
  }, [playVideo]);

  return (
    <>
      <div
        data-cy="Ecosystem Backround Video"
        className="video"
        ref={ref}
        dangerouslySetInnerHTML={{
          __html: `
      
      <video preload="metadata" muted loop playsinline paused>
          <source src="${videoMP4}" alt="${alt}" type="video/mp4"></source>
          <source src="${videoWebM}" alt="${alt}" type="video/webm"></source>
        </video>
      `,
        }}
      ></div>
      {/* {isLoaded || (
        <Image
          src={backupImage}
          className="image"
          alt="background-image-experiencia-movistar"
          fill
          objectFit="cover"
        />
      )} */}

      <style jsx>{style}</style>
    </>
  );
};

export default Video;

Video.defaultProps = {
  alt: "background-video",
};
